import { DirectusCalloutBlock } from 'config';
import { CalloutBlockProps } from '../../../components/blocks';

export const mapDirectusCalloutBlock = ({ copy }: DirectusCalloutBlock): CalloutBlockProps => {
  return {
    copy: copy,
  };
};
